import { all, put, call, select, takeLeading } from 'redux-saga/effects';

import * as $app from 'modules/app';
import * as $auth from 'modules/auth';
import * as $file from 'modules/file';
import * as actions from '../actions';
import { updateArtset } from '../helpers/updateArtset';
import { fetchSingleArtset } from '../helpers/fetchSingleArtset';
import { createArtProductServerConfiguration } from '../helpers/createArtProductServerConfiguration';

const uploadImage = function* (imageName, imageBlobUrl) {
  const token = yield select($auth.getToken);
  const publisherId = yield select($auth.getSelectedPublisherId);
  const imageFile = yield call($file.createFileFromImageUrl, imageBlobUrl);
  imageFile.name = imageName;

  const imageServerUrl = yield call($file.uploadImage, imageFile, {
    token,
    publisherId,
  });
  return imageServerUrl;
};

const getImageServerUrl = function* (imageName, imageBlobUrl) {
  if (imageBlobUrl.startsWith('blob:')) {
    const imageServerUrl = yield call(uploadImage, imageName, imageBlobUrl);
    return imageServerUrl;
  }

  return imageBlobUrl;
};

const createArtProduct = function* (artProduct) {
  const {
    name: imageName,
    image: imageBlobUrl,
    thumbnailImage: thumbnailImageBlobUrl,
  } = artProduct;

  const [imageServerUrl, thumbnailImageServerUrl] = yield all([
    call(getImageServerUrl, imageName, imageBlobUrl),
    call(getImageServerUrl, imageName, thumbnailImageBlobUrl),
  ]);

  const artProductServer = createArtProductServerConfiguration({
    ...artProduct,
    image: imageServerUrl,
    thumbnailImage: thumbnailImageServerUrl,
  });

  const artsetToUpdate = yield call(fetchSingleArtset);
  artsetToUpdate.Products.push(artProductServer);
  yield call(updateArtset, artsetToUpdate);
};

const submitArtProductCreate = function* ({ payload }) {
  const { artProduct } = payload;
  yield call(createArtProduct, artProduct);

  yield put($app.updateOnboardingSteps());

  const { callbacks } = payload;
  callbacks.onSuccess();
};

export const createArtProductSaga = function* () {
  yield takeLeading(actions.submitArtProductCreate, submitArtProductCreate);
};
